function reportWindowSize(e) {
    e.preventDefault();
//console.log('resize!');
}
window.onresize = reportWindowSize;
// var $ = jQuery.noConflict();
// A $( document ).ready() block.
jQuery(document).ready(function() {
    //console.log('ready!');
    // Menu Item Hover
    jQuery("li.menu-item").hover(onMenuItemHover, offMenuItemHover);
// setupNavFocusTrap();
});
function onMenuItemHover() {
    jQuery(this).addClass("active");
}
function offMenuItemHover() {
    if (window.location.href !== jQuery(this).find("a").attr("href")) {
        jQuery(this).removeClass("active");
    }
}
var lastScrollTop = 0;
var $header = jQuery("header.site-header");
jQuery(window).on("scroll", function() {
    var currentScroll = jQuery(window).scrollTop();
    if (currentScroll > lastScrollTop && currentScroll > 50) {
        // Scrolling down
        $header.removeClass("nav-visible").addClass("nav-hidden");
    } else if (currentScroll < lastScrollTop) {
        // Scrolling up
        $header.removeClass("nav-hidden").addClass("nav-visible");
    }
    lastScrollTop = currentScroll;
});
// function setupNavFocusTrap() {
//   // * Focus Trap
//   const focusableElements =
//     'button, [role="button"], [href], input, select, textarea, [tabindex]:not([tabindex="-1"])';
//   const modal = document.querySelector('.nav-modal'); // select the modal by it's id
//   // const firstFocusableElement = modal.querySelectorAll(focusableElements)[0]; // get first element to be focused inside modal
//   const initialFocusElement = document.querySelector('.site-logo a'); // get first element to be focused inside modal
//   const navToggleElement = document.querySelector('#navigation-toggle'); // get first element to be focused inside modal
//   const firstFocusableElement = modal.querySelector('.custom-logo-link'); // get first element to be focused inside modal
//   const focusableContent = modal.querySelectorAll(focusableElements);
//   const lastFocusableElement = focusableContent[focusableContent.length - 1]; // get last element to be focused inside modal
//   let lastItemFocused = false;
//   document.addEventListener('keydown', function(e) {
//     let isNavOpen = document
//       .querySelector('body')
//       .classList.contains('open-nav');
//     if (!isNavOpen) {
//       return;
//     }
//     let isTabPressed = e.key === 'Tab' || e.keyCode === 9;
//     let isEscPressed = e.key === 'Escape';
//     if (isEscPressed) {
//       jQuery('.site-header .site-navigation-toggle').click();
//       jQuery('.site-header .site-navigation-toggle').focus();
//       return;
//     }
//     if (!isTabPressed) {
//       return;
//     }
//     let shift = e.shiftKey;
//     if (shift) {
//       if (document.activeElement === firstFocusableElement) {
//         // shift-tab pressed on first input in dialog
//         lastFocusableElement.focus();
//         e.preventDefault();
//       }
//     } else {
//       if (document.activeElement === lastFocusableElement) {
//         // tab pressed on last input in dialog
//         firstFocusableElement.focus();
//         e.preventDefault();
//       }
//     }
//     // if (e.shiftKey) {
//     //   // if shift key pressed for shift + tab combination
//     //   if (
//     //     document.activeElement === firstFocusableElement &&
//     //     document.querySelector('body').classList.contains('open-nav')
//     //   ) {
//     //     lastFocusableElement.focus(); // add focus for the last focusable element
//     //     e.preventDefault();
//     //   } else if (
//     //     document.activeElement === navToggleElement &&
//     //     document.querySelector('body').classList.contains('open-nav')
//     //   ) {
//     //     firstFocusableElement.focus(); // add focus for the last focusable element
//     //     e.preventDefault();
//     //   }
//     // } else {
//     //   // if tab key is pressed
//     //   if (
//     //     document.activeElement === lastFocusableElement &&
//     //     document.querySelector('body').classList.contains('open-nav')
//     //   ) {
//     //     // if focused has reached to last focusable element set last item focused so next tab we go to the first
//     //     lastItemFocused = true;
//     //     // firstFocusableElement.focus(); // add focus for the first focusable element
//     //   } else if (lastItemFocused) {
//     //     lastItemFocused = false;
//     //     firstFocusableElement.focus();
//     //     e.preventDefault();
//     //   } else {
//     //     lastItemFocused = false;
//     //   }
//     // }
//   });
// }
document.addEventListener("DOMContentLoaded", function() {
    var currentPath = window.location.pathname;
    var menuLinks = document.querySelectorAll("#menu-main-nav a");
    menuLinks.forEach(function(link) {
        var linkPath = new URL(link.href).pathname;
        console.log("currentPath");
        console.log(currentPath);
        console.log("linkPath");
        console.log(linkPath);
        if (linkPath === currentPath) {
            link.closest(".heading-nav").classList.add("active");
        }
    });
    var solutionsMenuLinks = document.querySelectorAll("#menu-solutions-menu-navigation a");
    solutionsMenuLinks.forEach(function(link) {
        var linkPath = new URL(link.href).pathname;
        console.log("currentPath");
        console.log(currentPath);
        console.log("linkPath");
        console.log(linkPath);
        if (linkPath === currentPath) {
            document.querySelector("#solutions-navigation-toggle").classList.add("active");
        }
    });
});
document.addEventListener("DOMContentLoaded", function() {
    var initialDropdownLinks = document.querySelectorAll("#solutions-navigation-dropdown a, #site-navigation-dropdown a");
    initialDropdownLinks.forEach(function(link) {
        link.setAttribute("tabindex", "-1");
        link.setAttribute("aria-hidden", "true");
    });
});
document.addEventListener("DOMContentLoaded", function() {
    var toggleSolutionsDropdown = function toggleSolutionsDropdown() {
        var isOpen = body.classList.contains("open-solutions-nav");
        body.classList.toggle("open-solutions-nav", !isOpen);
        solutionsDropdown.setAttribute("aria-hidden", isOpen ? "true" : "false");
        solutionsToggle.classList.toggle("active", !isOpen);
        solutionsToggle.setAttribute("aria-expanded", isOpen ? "false" : "true");
        dropdownLinks.forEach(function(link) {
            link.setAttribute("tabindex", isOpen ? "-1" : "0");
        });
        if (!isOpen) {
            var firstTabbable = dropdownLinks.find(function(link) {
                return link.offsetParent !== null;
            });
            if (firstTabbable) firstTabbable.focus();
        }
    };
    var solutionsToggle = document.getElementById("solutions-navigation-toggle");
    var solutionsDropdown = document.getElementById("solutions-navigation-dropdown");
    var dropdownLinks = Array.from(solutionsDropdown.querySelectorAll("a"));
    var body = document.body;
    if (solutionsToggle) {
        solutionsToggle.addEventListener("keydown", function(e) {
            if (e.key === "Enter" || e.key === " " || e.keyCode === 13 || e.keyCode === 32) {
                e.preventDefault();
                toggleSolutionsDropdown();
            }
        });
        solutionsToggle.addEventListener("click", function() {
            toggleSolutionsDropdown();
        });
    }
    // 👇 Add this to detect when Tab leaves the last link
    var lastLink = dropdownLinks[dropdownLinks.length - 1];
    if (lastLink) {
        lastLink.addEventListener("keydown", function(e) {
            var isTab = e.key === "Tab" || e.keyCode === 9;
            var isForward = !e.shiftKey;
            if (isTab && isForward && body.classList.contains("open-solutions-nav")) {
                // Close dropdown
                toggleSolutionsDropdown();
                // Wait for the DOM to update, then move to the next element
                setTimeout(function() {
                    var focusable = document.querySelector('.nav-menu-section-inner > #menubar-wrapper a[aria-label="Our Difference"]');
                    if (focusable) {
                        focusable.focus();
                        window.scrollTo(0, 0);
                    }
                }, 0);
            }
        });
    }
});
document.addEventListener("DOMContentLoaded", function() {
    var ul = document.querySelector(".mobile-only ul#menu-main-nav.menubar-navigation");
    if (ul) {
        var li = document.createElement("li");
        li.className = "heading-nav transition-delay-600 menu-item menu-item-type-post_type menu-item-object-page";
        li.innerHTML = '<a href="/what-we-offer" tabindex="-1" aria-label="Roundel™ Kiosk Login">Solutions</a>';
        ul.insertBefore(li, ul.firstChild);
    }
});
